import { render, staticRenderFns } from "./viewed-products.vue?vue&type=template&id=a5e00c9a"
import script from "./viewed-products.vue?vue&type=script&lang=js"
export * from "./viewed-products.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductCollection: require('C:/cata1og/cata1og-store/components/product/product-collection.vue').default})
